export const getSignIn = (state) => state.auth.signIn;
export const getLoading = (state) => state.auth.signIn.loading;
